export const alternateTexts = {
    logo: 'Logo',
    Warehouse: 'Sklad',
    Box: 'Box',
    Podorys: 'Podorys',
    Bird: 'Vták',
    Steps: 'Kroky',
    DownloadApp: 'Sťiahnúť aplikáciu',
    PaymentCard: 'Platobná karta',
    LandingImage: 'Boxyland stena s krabicami',
    FranchiseImage: 'Boxyland sídlo',
    BusinessMan: 'Businessman'
}
